/**
 * Text utilities.
 *
 * Used to assist with displaying retrofont data.
 *
 * @type {Object}
 */
Game.Utils.Text = {

	/**
	 * Wrap retro font text to fit within a 64 pixel width.
	 *
	 * @param  {string} text The text to wordwrap.
	 * @return {string}      The wrapped text.
	 */
	wrap: function( text ) {

		var max_length = 60;
		var character_size = 4;
		var message = '';

		text = text.replace( /\|/g, "\n" );

		var sentences = text.split( "\n" );

		// Loop through sentences.
		for ( var i = 0; i < sentences.length; i++ ) {

			var words = sentences[ i ].split( ' ' );
			var line_length = 0;

			for ( var j = 0; j < words.length; j++ ) {

				var word = words[j].trim();

				if ( word.length < 1 ) {
					continue;
				}

				var word_length = ( word.length + 1 ) * character_size;

				line_length += word_length;

				if ( line_length > max_length ) {
					message += "\n";
					line_length = word_length;
				}

				message += word + ' ';

			}

			message += "\n";
			line_length = 0;

		}

		return message;

	},

};
